import React from "react"
//@ts-ignore
import * as css from "./css.module.scss"
type Props = {
  version: string
}
export default function Version(props: Props) {
  return <code className={css.version}>Version {props.version}</code>
}
